import React from 'react';

const Sabadabadoo = () => {
    return (
        <div style={{ position: 'relative', width: '100vw', height: '100vh', overflow: 'hidden' }}>
            {/* Background Image */}
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundImage: "url('https://lcmobilerepairs.com.au/IMG_4689.JPG')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center 28%',
                    filter: 'contrast(1.12) saturate(1.18) brightness(1.08)',
                    zIndex: 1,
                }}
            />

            {/* Dark Overlay */}
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'rgba(0, 0, 0, 0.42)',
                    zIndex: 2,
                }}
            />

            {/* Rainbow Text */}
            <div
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    textAlign: 'center',
                    zIndex: 10,
                }}
            >
                <div
                    style={{
                        fontSize: '5.8rem',
                        fontWeight: 900,
                        lineHeight: 1,
                        letterSpacing: '-0.04em',
                        fontFamily: 'Impact, sans-serif',
                        animation: 'rainbow 4.2s linear infinite',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        textShadow: '0 0 30px rgba(0,0,0,0.95)',
                        backgroundImage: 'linear-gradient(90deg, #ff00ff, #00ffff, #ffff00, #ff0000, #00ff00, #0000ff)',
                        backgroundSize: '400%',
                    }}
                >
                    <div>SABADABADOO WHERE ARE YOU</div>
                    <div>WE'VE GOT A LOT TO DO NOW</div>
                </div>
            </div>



            <style>
                {`
          @keyframes rainbow {
            0%   { background-position: 0% 50%; }
            50%  { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `}
            </style>
        </div>
    );
};

export default Sabadabadoo;